( ( wp ) => {
  function handleFormSuccessSubmitMeta( metadata ) {
    const { layout } = metadata;

    let targetVal = '_self';

    if ( ['custom_url', 'download_redirect'].includes( layout ) ) {
      const targetProp = metadata[layout].target;
      targetVal = targetProp ? '_blank' : '_self';
    }

    switch ( layout ) {
    case 'custom_url':
      openWindow( metadata.custom_url.url, targetVal );
      location.reload();
      break;
    case 'download':
      openWindow( metadata.download.download, '_blank' );
      location.reload();
      break;
    case 'download_redirect':
      openWindow( metadata.download_redirect.download, '_blank' );
      openWindow( metadata.download_redirect.url, targetVal );
      location.reload();
      break;
    case 'thank_you_download_cta':
      handleThankYouDownloadCta( metadata );
      break;
    case 'view_resource_on_same_page':
      handleViewResourceOnSamePage( metadata );
      break;
    default:
      break;
    }
  }

  /* eslint-disable no-undef */
  function getFormSuccessMetadata( formUrl, action = 'auth' ) {
    wp.apiRequest( {
      path: '/dtex/v1/gated-form-success-metadata',
      data: {
        postId: GATED_FORMS__postID,
        formUrl: formUrl,
        action,
      },
    } ).then( metadata => {
      if ( metadata !== 'ungated' ) {
        handleFormSuccessSubmitMeta( metadata );
      }
    } );
  }
  /* eslint-enable */

  if ( document.querySelectorAll( 'iframe' ).length ) {
    getFormSuccessMetadata(); // Get content on load if cookie exists
    window.addEventListener( 'message', ( event ) => {
      const allowedOrigins = ['https://www2.dtexsystems.com'];
      const eventData = event.data;

      if ( allowedOrigins.includes( event.origin ) && eventData.message === 'PARDOT_FORM_SUCCESS' ) {
        setTimeout( () => {
          const offsetPositionValue = document.querySelector( '.e-div--demo-form' ).offsetTop;
          window.scrollTo( {
            top: offsetPositionValue + document.querySelector( 'header' ).offsetHeight - 200,
            behavior: 'smooth'
          } );
        }, 2000 );

        getFormSuccessMetadata( eventData.formUrl, 'fetch' );
      }
    }, false );
  } /* eslint-disable no-undef */

} )( wp );

function openWindow( url, target = '_self' ) {
  window.open( url, target );
}

function handleThankYouDownloadCta( metadata ) {
  const { download, postId } = metadata.thank_you_download_cta;
  const downloadUrl = download;
  const encodedParams = btoa( downloadUrl );
  const encodedPostId = btoa( postId );
  openWindow( `${metadata.thank_you_download_cta.url}?file=${encodedParams}&postId=${encodedPostId}`, '_self' );
}

function handleViewResourceOnSamePage( metadata ) {
  const date = new Date();
  date.setTime( date.getTime() + metadata.view_resource_on_same_page.cookie * 24 * 60 * 60 * 1000 );
  const cookieName = 'resource_' + GATED_FORMS__postID;
  document.cookie = `${cookieName}=resource-same-page;expires=${date.toUTCString()}; path=/`;
  setTimeout( () => {
    location.reload( true );
  }, 1000 );
}